//导入three.js
import * as THREE from "three";
import { SpriteMaterial } from "three";
//导入控制器
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
//导入GLTF模型
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader.js";
//导入一个three.js的鼠标移入事件
// import onevent from  "three-onevent"
import { TWEEN } from "./tween.module.min";

//场景 相机 渲染器 控制器
class ThreeDimensional {
  constructor(canvas) {
    const scope = this;
    //画布
    this.canvas = null;
    //摄像机
    this.camera = null;
    //场景
    this.scene = null;
    //渲染器
    this.renderer = null;
    //控制器
    this.controls = null;
    this.skybox = null;
    //鼠标移入事件
    this.raycaster = null;
    this.pointer = null;
    //初始化材质
    this.oldMaterial = null;
    //设置透明度
    this.animationMap = null;
    this.testobj = null;
    this.testobj1 = null;
    this.testobj2 = null;
    this.testobj3 = null;
    this.testobj4 = null;
    this.testobj5 = null;
    //模型图表的数组
    this.InfoUIArray = []; 
    this.InfoUIdata = [];
    this.echartsUI = [];
    //模型的数据
    this.modelData = [];
    this.modelArray = [];
    //模型动画
    this.s_mixer = null;
    this.action = null;
    this.clock = null;
    //精灵data
    this.spriteInfo = [];
    this.isFirst = true;
    this.InfoImg = null;
    //流光
    this.timeMap = null;
    //定时器
    this.getDataInterval = null;
    //获取到工厂信息按钮的dome
    this.piantBottnDome = null;
    //车间机器模型是否显示
    this.Modelflag = null;
    this.divice3 = null;
    this.SetcMType_out = (num) => {
      if (num == 0) {
        //关闭全部房顶
        clone(null, 0);
        //点击屋顶关闭车间的模型
        scope.Modelflag.visible = false;
        MoveCamera(
          {
            x: -3.919387679172059,
            y: 1.3072793090297266,
            z: 9.454511138751275,
          },
          1000
        );
        scope.controls.target.set(
          -3.9123034047153893,
          -2.522676072739623,
          -3.6613832362710257
        );
      } else {
        //关闭全部房顶
        clone(null, 0);
        //点击屋顶关闭车间的模型
        scope.Modelflag.visible = false;
        MoveCamera(
          {
            x: -12.190585155199493,
            y: 0.8479844719308298,
            z: 5.218550747555982,
          },
          1000
        );
        scope.controls.target.set(
          -5.043777531600057,
          -3.7316890306416504,
          0.41044259620983947
        );
      }
    };
    /**
     * 艾建兵
     * 初始加载
     * 初始化画布
     * 初始化场景
     * 初始化渲染器
     * 初始化摄像机
     * 初始化控制器
     * 初始化特效通道
     */
    onLoad();
    function onLoad() {
      // document.onkeydown = function (event) {
      //   if (event.keyCode == 13) {
      //     //事件
      //     console.log(scope.camera.position);
      //     console.log(scope.controls.target);
      //   }
      // };
      LoadImg('./img/info.png');
      //获取画布
      scope.canvas = document.getElementById(canvas);
      //初始化场景
      scope.scene = new THREE.Scene();
      scope.skybox = new THREE.CubeTextureLoader().load([
        "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/SkyBox/smartfactory/1.jpg",
        "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/SkyBox/smartfactory/2.jpg",
        "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/SkyBox/smartfactory/3.jpg",
        "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/SkyBox/smartfactory/4.jpg",
        "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/SkyBox/smartfactory/5.jpg",
        "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/SkyBox/smartfactory/6.jpg",
      ]);
      scope.scene.background = scope.skybox;

      let environment = new THREE.CubeTextureLoader().load([
        "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/SkyBox/BlurredLocation/1.png",
        "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/SkyBox/BlurredLocation/2.png",
        "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/SkyBox/BlurredLocation/3.png",
        "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/SkyBox/BlurredLocation/4.png",
        "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/SkyBox/BlurredLocation/5.png",
        "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/SkyBox/BlurredLocation/6.png",
      ]);
      scope.scene.environment = environment;
      
      //初始化相机
      scope.camera = new THREE.PerspectiveCamera(
        75,
        scope.canvas.clientWidth / scope.canvas.clientHeight,
        0.1,
        1000
      );
      scope.camera.position.set(
        -5.830564902582744,
        -0.5867231577543727,
        8.350197542529175,
      );


      //初始化渲染器
      scope.renderer = new THREE.WebGLRenderer({
        antialias: true,
      });
      scope.renderer.physicallyCorrectLights= true;
      scope.renderer.setPixelRatio(window.devicePixelRatio);
      scope.renderer.setSize(
        scope.canvas.clientWidth,
        scope.canvas.clientHeight
      );
      scope.clock = new THREE.Clock();
      //添加到画布
      scope.canvas.appendChild(scope.renderer.domElement);
      scope.renderer.render(scope.scene, scope.camera);
      //添加环境灯光
      const light = new THREE.AmbientLight(0xffffff, 3.2);
      scope.scene.add(light);

      //初始化控制器
      scope.controls = new OrbitControls(
        scope.camera,
        scope.renderer.domElement,
      );
      scope.controls.enableDamping = true;
      scope.controls.dampingFactor = 0.05;
      scope.controls.minDistance = 0.5;
      scope.controls.maxDistance = 30; //限制缩放多少
      scope.controls.maxPolarAngle = 0.5 * Math.PI
      scope.controls.target.set(
          -5.88227371280261,
          -0.5867231578494687,
          -2.221681930222653
      );
      scope.controls.mouseButtons = {
        LEFT: THREE.MOUSE.ROTATE,
        MIDDLE: THREE.MOUSE.PAN,
        RIGHT: THREE.MOUSE.PAN
      }

      //创建一个平面
      let PlaneTexture = new THREE.TextureLoader().load("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/smartfactory/textures/Plane.png");
      PlaneTexture.wrapS = THREE.RepeatWrapping;
      PlaneTexture.wrapT = THREE.RepeatWrapping;
      PlaneTexture.repeat.x = 100;
      PlaneTexture.repeat.y = 100;
      const PlaneGeometry = new THREE.PlaneGeometry(600, 600);
      const PlaneMaterial = new THREE.MeshBasicMaterial({
        map: PlaneTexture,
        transparent: true,
        color: 0xa0d9fb,
        reflectivity: 0.1,
        side: THREE.DoubleSide, //材质双面可见
      });
      const Plane = new THREE.Mesh(PlaneGeometry, PlaneMaterial);
      Plane.rotation.set(-0.5 * Math.PI, 0, 0);
      Plane.position.set(0, -1.6, 0);
      scope.scene.add(Plane);

      //echarts图标显示
      //导入一个纹理
      const InfoTexture = new THREE.TextureLoader().load("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/smartfactory/textures/AMTA.png");
      //设置一个精灵
      const InfoUI = new THREE.Sprite();
      InfoUI.material = new SpriteMaterial({
        map: InfoTexture,
      });
      InfoUI.position.set(-10.5, -0.65, 3);
      scope.scene.add(InfoUI);
      scope.InfoUIArray.push(InfoUI);

      const InfoTexture2 = new THREE.TextureLoader().load("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/smartfactory/textures/AMTB.png");
      const InfoUI2 = new THREE.Sprite();
      InfoUI2.material = new SpriteMaterial({
        map: InfoTexture2,
      });
      InfoUI2.position.set(-1, -0.7, 3);
      scope.scene.add(InfoUI2);
      scope.InfoUIArray.push(InfoUI2);

      const InfoTexture3 = new THREE.TextureLoader().load("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/smartfactory/textures/LDC.png");
      const InfoUI3 = new THREE.Sprite();
      InfoUI3.material = new SpriteMaterial({
        map: InfoTexture3,
      });
      InfoUI3.position.set(-7.5, -0.7, 4.7);
      scope.scene.add(InfoUI3);
      scope.InfoUIArray.push(InfoUI3);

      const InfoTexture4 = new THREE.TextureLoader().load("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/smartfactory/textures/LDCB.png");
      const InfoUI4 = new THREE.Sprite();
      InfoUI4.material = new SpriteMaterial({
        map: InfoTexture4,
      });
      InfoUI4.position.set(-4, -0.7, 4.7);
      scope.scene.add(InfoUI4);
      scope.InfoUIArray.push(InfoUI4);

      const InfoTexture5 = new THREE.TextureLoader().load("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/smartfactory/textures/LDCC.png");
      const InfoUI5 = new THREE.Sprite();
      InfoUI5.material = new SpriteMaterial({
        map: InfoTexture5,
      });
      InfoUI5.position.set(-4, -0.7, 0.5);
      scope.scene.add(InfoUI5);
      scope.InfoUIArray.push(InfoUI5);

      const InfoTexture6 = new THREE.TextureLoader().load("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/smartfactory/textures/LDCD.png");
      const InfoUI6 = new THREE.Sprite();
      InfoUI6.material = new SpriteMaterial({
        map: InfoTexture6,
      });
      InfoUI6.position.set(-7.5, -0.7, 0.5);
      scope.scene.add(InfoUI6);
      scope.InfoUIArray.push(InfoUI6);
      CreateSprite();
      // 添加一个鼠标点击事件
      scope.raycaster = new THREE.Raycaster();
      scope.pointer = new THREE.Vector2();
      function onPointerMove(event,size) {
        // 将鼠标位置归一化为设备坐标。x 和 y 方向的取值范围是 (-1 to +1)
        scope.pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
        scope.pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
        // 通过鼠标点的位置和当前相机的矩阵计算出raycaster
        scope.raycaster.setFromCamera(scope.pointer, scope.camera);
        // 获取raycaster直线和所有模型相交的数组集合
        var intersects = scope.raycaster.intersectObjects(scope.divice3.children);
          if (intersects.length > 0) {
            let selectObjects = [];
            selectObjects.push(intersects[0].object);
            //打印点击到的物体
            console.log(intersects[0].object.name);
            SetSpriteVisible(HasClickObj(intersects[0].object.name));
        } else {
            //没有点击到物体
            SetSpriteVisible(null);
        }
      }
      window.addEventListener("click", onPointerMove, false);

      // 添加光源
      // const abmlight = new THREE.AmbientLight(0xffffff, 0.7);
      // scope.scene.add(abmlight);
      //导入模型
      const loader = new GLTFLoader();
      loader.load("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/smartfactory/scene.glb", (gltf) => {
        let model = gltf.scene;
        model.traverse((child) => {
          if (child.isMesh) {
            if (child.name == "屋顶2_Instance") {
              child.material = child.material.clone();
              scope.modelArray[4] = child;
            } else if (child.name == "屋顶2_Instance_2") {
              child.material = child.material.clone();
              scope.modelArray[5] = child;
            } else if (child.name == "屋顶2_Instance_3") {
              child.material = child.material.clone();
              scope.modelArray[1] = child;
            } else if (child.name == "屋顶2") {
              child.material = child.material.clone();
              scope.modelArray[2] = child;
            } else if (child.name == "屋顶1") {
              child.material = child.material.clone();
              scope.modelArray[6] = child;
            } else if (child.name == "屋顶1_Instance") {
              scope.modelArray[0] = child;
              child.material = child.material.clone();
            } 
          }
        });
        scope.scene.add(model);
        model.scale.set(0.1, 0.1, 0.1);
        model.position.set(0, -2, 0);
      });
      //导入流光模型
      const loader5 = new GLTFLoader();
      loader5.load("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/smartfactory/time.glb",(gltf)=>{
        let model = gltf.scene;
        model.traverse((child) => {
          if (child.isMesh) {
            scope.timeMap = child.material.map;
            child.material.map = scope.timeMap;
          }
        })
        scope.timeMap.wrapS = THREE.RepeatWrapping;
        scope.timeMap.wrapT = THREE.RepeatWrapping;
        scope.scene.add(model);
        model.scale.set(0.1, 0.1, 0.1);
        model.position.set(0, -2, 0);
      })

      //导入车间机器模型
      const loader2 = new GLTFLoader();
      loader2.load("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/smartfactory/divice.glb", (gltf) => {
        const model = gltf.scene;
        scope.scene.add(model);
        model.visible = false;
        scope.Modelflag = model;
        model.scale.set(0.1, 0.1, 0.1);
        model.position.set(0, -2, 0);
      });
      //导入精灵模型
      const loader4 = new GLTFLoader();
      loader4.load("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/smartfactory/sprite.glb", (gltf) => {
        const model = gltf.scene;
        scope.scene.add(model);
        model.traverse((child)=>{
          if (child.isMesh) {
            if (child.name.indexOf("Box_") != -1) {
              child.visible = false;
            }
          }
          if(child.name.indexOf("Sprite_") != -1){
            let sprite = new THREE.Sprite();
            child.add(sprite);
            sprite.visible = false;
            scope.spriteInfo[child.name.replace('Sprite_', 'Box_')] = child.children[0];
          }
        })
        scope.divice3 = model;
        model.scale.set(0.1, 0.1, 0.1);
        model.position.set(0, -2, 0);
      });
    
      const loader3 = new FBXLoader();
      loader3.load("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/model/smartfactory/Car.fbx", (fbx) => {
        const model = fbx;
        scope.scene.add(model);
        model.scale.set(0.001, 0.001, 0.001);
        model.position.set(-0.8, -1.24, 1.5);
        //动画
        scope.s_mixer = new THREE.AnimationMixer(fbx);
        scope.action = scope.s_mixer.clipAction(fbx.animations[0]);
        scope.action.clampWhenFinished = true;
        scope.action.loop = THREE.LoopPingPong;
        scope.action.paused = false;
        scope.action.enabled = true;
        scope.action.timeScale = 0.7;
        scope.action.play(); 
      });
      //场景渲染
      animate();
      //屏幕自适应
      adaption();
    }

    this.EventClick = (index) => {
      if (index == 3) {
        //点击屋顶关闭车间的模型
        setTimeout(() => {
        scope.Modelflag.visible = false;
          
        }, 1000);
        clone(null, 0);
        MoveCamera(
          {
            x:-5.830564902582744,
            y:-0.5867231577543727,
            z:8.350197542529175,
          },
          1000
        );
        scope.controls.target.set(
          -5.88227371280261,
          -0.5867231578494687,
          -2.221681930222653
        );
      }else{
        ClickFunction(scope.modelArray[index])
      }
    }

    function ClickFunction(object) {  
     if (object.name == "屋顶2_Instance") {
       //点击屋顶打开车间的模型
       scope.Modelflag.visible = true;
       scope.modelData.push(object);
       scope.echartsUI.push(scope.InfoUIArray[4]);
       clone(object, 1, scope.InfoUIArray[4],scope.InfoUIdata[4]);
       //隐藏图表数据
       scope.InfoUIdata[4].visible = false;
       //隐藏图标
       setTimeout(() => {
        scope.InfoUIArray[4].visible = false;
       }, 100);
       let data = object;
       scope.testobj = data;
       if (scope.oldMaterial == null) {
         scope.oldMaterial = data.material;
       }
       initTween(data, true, 0);
       initgoup(data, true, 1000);
       MoveCamera(
         {
           x: -4.140532717111243,
           y: -0.964315254091213,
           z: 1.8824590587633603,
         },
         1000
       );
       scope.controls.target.set(
        -3.976013172644002,
        -3.232226466617611,
        -3.3525778668006962
       );
     } else if (object.name == "地面_Instance") {
       initTween(scope.testobj, false, 1);
       initgoup(scope.testobj, false, 205);
       //500毫秒显示图表
       setTimeout(() => {
         //显示图表
         scope.InfoUIArray[4].visible = true;
         scope.InfoUIdata[4].visible = true;
         //调用一次图表数据渲染上去
         PlaneText();
         //点击地面隐藏模型
         scope.Modelflag.visible = false;
       }, 500);
     } else if (object.name == "屋顶2_Instance_2") {
       //点击屋顶打开车间的模型
       scope.Modelflag.visible = true;
       scope.modelData.push(object);
       scope.echartsUI.push(scope.InfoUIArray[5]);
       clone(object,1, scope.InfoUIArray[5],scope.InfoUIdata[5]);
       //隐藏图表数据
       scope.InfoUIdata[5].visible = false;
       //隐藏图标
       setTimeout(() => {
        scope.InfoUIArray[5].visible = false;
       }, 100);
       let data1 = object;
       scope.testobj1 = data1;
       if (scope.oldMaterial == null) {
         scope.oldMaterial = data1.material;
       }
       if (data1.material.opacity == 0) {
         initTween(data1, false, 1);
         initgoup(data1, false, 205);
       } else {
         initTween(data1, true, 0);
         initgoup(data1, true, 1000);
       }
       MoveCamera(
         {
           x: -7.669898898306563,
           y: -0.9702847561120884,
           z: 1.8518195945507365,
         },
         1000
       );
       scope.controls.target.set(
        -7.619261209682158,
        -3.7159580264532575,
        -3.1520551783934065
       );
     } else if (object.name == "地面_Instance_2") {
       //500毫秒显示图表
       setTimeout(() => {
         //显示图表
         scope.InfoUIArray[5].visible = true;
         scope.InfoUIdata[5].visible = true;
         //调用一次图表数据渲染上去
         PlaneText();
         //点击地面隐藏模型
         scope.Modelflag.visible = false;
       }, 500);
       initTween(scope.testobj1, false, 1);
       initgoup(scope.testobj1, false, 205);
     } else if (object.name == "屋顶2_Instance_3") {
       //点击屋顶打开车间的模型
       scope.Modelflag.visible = true;
       scope.modelData.push(object);
       scope.echartsUI.push(scope.InfoUIArray[2]);
       clone(object, 1, scope.InfoUIArray[2],scope.InfoUIdata[2]);
       //隐藏图表数据
       scope.InfoUIdata[2].visible = false;
       let data = object;
       setTimeout(() => {
        scope.InfoUIArray[2].visible = false;
       }, 100);
       scope.testobj2 = data;
       if (scope.oldMaterial == null) {
         scope.oldMaterial = data.material;
       }
       initTween(data, true, 0);
       initgoup(data, true, 1000);
       MoveCamera(
         {
           x: -7.457921734277173,
           y: -0.7474248087141047,
           z: 5.764420656843462,
         },
         1000
       );
       scope.controls.target.set(
         -7.406456594013167,
         -3.462359598365086,
         -3.376372453800295
       );
     } else if (object.name == "地面_Instance_3") {
       setTimeout(() => {
        scope.InfoUIArray[2].visible = true;
         scope.InfoUIdata[2].visible = true;
         //调用一次图表数据渲染上去
         PlaneText();
         //点击地面隐藏模型
         scope.Modelflag.visible = false;
       }, 500);
       initTween(scope.testobj2, false, 1);
       initgoup(scope.testobj2, false, 205);
     } else if (object.name == "屋顶2") {
       //点击屋顶打开车间的模型
       scope.Modelflag.visible = true;
       scope.modelData.push(object);
       scope.echartsUI.push(scope.InfoUIArray[3]);
       clone(object, 1, scope.InfoUIArray[3],scope.InfoUIdata[3]);
       scope.InfoUIdata[3].visible = false;
       //隐藏图标
       setTimeout(() => {
        scope.InfoUIArray[3].visible = false;
       }, 100);
       let data = object;
       scope.testobj3 = data;
       if (scope.oldMaterial == null) {
         scope.oldMaterial = data.material;
       }
       initTween(data, true, 0);
       initgoup(data, true, 1000);
       MoveCamera(
         {
           x:-4.125915324254497,
           y:-1.0177211580932863,
           z:5.460813107128935,
         },
         1000
       );
       scope.controls.target.set(
        -4.316423581531045,
        -4.243895932105689,
        -3.046798527052631
       );
     } else if (object.name == "地面") {
       initTween(scope.testobj3, false, 1);
       initgoup(scope.testobj3, false, 205);
       //500毫秒显示图表
       setTimeout(() => {
         //显示图表
         scope.InfoUIArray[3].visible = true;
         scope.InfoUIdata[3].visible = true;
         //点击地面隐藏模型
         scope.Modelflag.visible = false;
       }, 500);
     } else if (object.name == "屋顶1") {
       scope.modelData.push(object);
       scope.echartsUI.push(scope.InfoUIArray[1]);
       clone(object, 1, scope.InfoUIArray[1] ,scope.InfoUIdata[1]);
       //点击屋顶关闭车间的模型
       scope.Modelflag.visible = false;
       let data = object;
       //隐藏图表数据
       scope.InfoUIdata[1].visible = false;
       //隐藏图标
       setTimeout(() => {
        scope.InfoUIArray[1].visible = false;
       }, 100);
       scope.testobj4 = data;
       if (scope.oldMaterial == null) {
         scope.oldMaterial = data.material;
       }
       initTween(data, true, 0);
       initgoup(data, true, 1000);
       MoveCamera(
         {
           x: -2.80858974823214,
           y: 1.1029188782700234,
           z: 2.384130093970194,
         },
         1000
       );
       scope.controls.target.set(
         -0.5853204118090514,
         -1.6642473487192955,
         2.4160255857840327
       );
     } else if (object.name == "地面_2") {
       initTween(scope.testobj4, false, 1);
       initgoup(scope.testobj4, false, 205);
       //500毫秒显示图表
       setTimeout(() => {
         //显示图表
         scope.InfoUIArray[1].visible = true;
         scope.InfoUIdata[1].visible = true;
         //调用一次图表数据渲染上去
         PlaneText();
       }, 500);
     } else if (object.name == "屋顶1_Instance") {
       scope.modelData.push(object);
       scope.echartsUI.push(scope.InfoUIArray[0]);
       clone(object, 1, scope.InfoUIArray[0] ,scope.InfoUIdata[0]);
       setTimeout(() => {
       //点击屋顶关闭车间的模型
       scope.Modelflag.visible = false;
       }, 1000);
       //隐藏图表数据
       scope.InfoUIdata[0].visible = false;
       //隐藏图表
       scope.InfoUIArray[0].visible = false;
       let data = object;
       scope.testobj5 = data;
       if (scope.oldMaterial == null) {
         scope.oldMaterial = data.material;
       }
       initTween(data, true, 0);
       initgoup(data, true, 1000);
       MoveCamera(
         {
           x: -13.179635270923953,
           y: 0.5916195441214263,
           z: 2.720663013484531,
         },
         1000
       );
       scope.controls.target.set(
         -0.6311219970495313,
         -1.9089168788004574,
         2.4938446747110237
       );
     } else if (object.name == "地面_Instance_4") {
       initTween(scope.testobj5, false, 1);
       initgoup(scope.testobj5, false, 205);
       //500毫秒显示图表
       setTimeout(() => {
         //显示图表
         scope.InfoUIArray[0].visible = true;
         scope.InfoUIdata[0].visible = true;
         //调用一次图表数据渲染上去
         PlaneText();
       }, 500);
     }
    }

    //相机的位置移动
    function MoveCamera(p2 = { x: 0, y: 0, z: 0 }, time) {
      let p1 = scope.camera.position;
      scope.controls.target = new THREE.Vector3(0, 0, 0);
      scope.controls.enabled = false;
      scope.controls.enableDamping = false;
      var _tween = new TWEEN.Tween(p1)
        .to(p2, time)
        .easing(TWEEN.Easing.Quadratic.InOut)
        .start();
      var update = function () {
        scope.camera.position.set(p1.x, p1.y, p1.z);
      };
      _tween.onUpdate(update);
      setTimeout(function () {
        scope.controls.enabled = true;
        scope.controls.enableDamping = true;
      }, time);
      return _tween;
    }

    //房顶动画隐藏
    function initTween(obj, flage, value) {
      obj.material.transparent = flage;
      let a = { x: obj.material.opacity };
      let b = { x: value };
      var tween = new TWEEN.Tween(a).to(b, 500).start();
      var update = function () {
        obj.material.opacity = a.x;
      };
      tween.onUpdate(update);
      return tween;
    }
    //房顶上升
    function initgoup(obj, flage, value) {
      let a = { x: obj.position.y };
      let b = { x: value };
      var tween = new TWEEN.Tween(a).to(b, 500).start();
      var update = () => {
        obj.position.y = a.x;
      };
      tween.onUpdate(update);
      return tween;
    }

    //清除所有UI
    function CleanSprite() {
      for (let i = 0; i < scope.InfoUIdata.length; i++) {
        scope.InfoUIdata[i].geometry.dispose();
        scope.InfoUIdata[i].material.dispose();
        scope.scene.remove(scope.InfoUIdata[i]);
      }
    }

    function CreateSprite() {
      for (let i = 0; i < scope.InfoUIArray.length; i++) {
        scope.InfoUIdata[i] = new THREE.Sprite();
        scope.InfoUIdata[i].material = new SpriteMaterial({
          color: "#fff",
        });
        scope.InfoUIdata[i].position.x = scope.InfoUIArray[i].position.x;
        scope.InfoUIdata[i].position.y = scope.InfoUIArray[i].position.y;
        scope.InfoUIdata[i].position.z = scope.InfoUIArray[i].position.z;
        scope.scene.add(scope.InfoUIdata[i]);  
      }
    }


    PlaneText();
    scope.getDataInterval = setInterval(() => {
      PlaneText();
      SetData();
    }, 2000);
    //创建画布把数据放入图表里面
    function PlaneText() {
      try {
        //CleanSprite();
      } catch (error) {
        console.log(error);
      }
      for (let i = 0; i < scope.InfoUIArray.length; i++) {
        let ran = (Math.floor(Math.random() * 10) + 1) * 123;
        let ran1 = Math.floor(Math.random() * 100) + 1;
        let ran2 = Math.floor(Math.random() * 100) + 1;
        //创建画布
        CreatText4(
          scope.InfoUIdata[i],
          ran.toString(),
          ran1.toString(),
          ran2.toString()
        );
      }
    }



    //创建画布
    function CreatText4(geometry, messige, index, data) {
      var TextCanvas = document.createElement("canvas");
      var context = TextCanvas.getContext("2d");
      TextCanvas.width = 200 * 2;
      TextCanvas.height = 200 * 2;
      context.scale(2, 2);
      var texture = new THREE.Texture(TextCanvas);
      texture.needsUpdate = true;
      geometry.material.dispose();
      geometry.material = new SpriteMaterial({
        color: "#fff",
        map : texture
      }); 
      /*字体颜色*/
      context.fillStyle = "rgba(255,255,255,1)";
      context.shadowColor = "rgba(0, 0, 0, 1)";
      //将阴影向右移动15px，向上移动10px
      context.shadowOffsetX = 2;
      context.shadowOffsetY = 2;
      //轻微模糊阴影
      context.shadowBlur = 2;
      context.font = "18px Arboria";
      context.fillStyle = "#fff";
      context.fillText(messige + "PCS/H", 95, 55);
      context.fillText(data + "%", 110, 80);
      context.fillText(index + "%", 110, 105);
    }

    let count = 9852;
    function SetData() {          
      count++;
      //SMT-A车间
      creatCanvas(['A-SMT-01', '产线状态:', '运行速度:','健康分析:'],[random(9155,9855) + 'w',random(21000,35000) + 'v',"良好"],scope.spriteInfo["Box_SMT1"]);
      creatCanvas(['A-SMT-02', '产线状态:', '运行速度：','健康分析:'],[random(9155,9855) + 'w',random(21000,35000) + 'v',"良好"],scope.spriteInfo["Box_SMT2"]);
      creatCanvas(['A-SMT-03', '产线状态:', '运行速度：','健康分析:'],[random(9155,9855) + 'w',random(21000,35000) + 'v',"良好"],scope.spriteInfo["Box_SMT3"]);
      //SMT-B车间
      creatCanvas(['B-SMT-01', '产线状态:', '运行速度:','健康分析:'],[random(9155,9855) + 'w',random(21000,35000) + 'v',"良好"],scope.spriteInfo["Box_SMT_Line_1_2"]);
      creatCanvas(['B-SMT-02', '产线状态:', '运行速度：','健康分析:'],[random(9155,9855) + 'w',random(21000,35000) + 'v',"良好"],scope.spriteInfo["Box__SMT_Line_3"]);
      creatCanvas(['B-SMT-03', '产线状态:', '运行速度：','健康分析:'],[random(9155,9855) + 'w',random(21000,35000) + 'v',"良好"],scope.spriteInfo["Box__SMT_Line_4"]);
      //锂电池A车间
      creatCanvas(['A-辊压机-01', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_1_2_1"]);
      creatCanvas(['A-辊压机-02', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_1_3_1"]);
      creatCanvas(['A-辊压机-03', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_1_4_1"]);
      creatCanvas(['A-涂布机-01', '辊压功率：', '辊压电压：','辊压频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_2涂布机glb_5_12"]);
      creatCanvas(['A-涂布机-02', '辊压功率：', '辊压电压：','辊压频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_2涂布机glb_5"]);
      creatCanvas(['A-涂布机-03', '辊压功率：', '辊压电压：','辊压频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_2涂布机glb_5_2"]);
      creatCanvas(['A-辊压机-04', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_1_8"]);
      creatCanvas(['A-辊压机-05', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_1"]);
      creatCanvas(['A-辊压机-06', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_1_1"]);
     //锂电池B车间
     creatCanvas(['B-辊压机-01', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_3"]);
     creatCanvas(['B-辊压机-02', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_5"]);
     creatCanvas(['B-辊压机-03', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_4"]);
     creatCanvas(['B-涂布机-01', '辊压功率：', '辊压电压：','辊压频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_2涂布机glb_5_3"]);
     creatCanvas(['B-涂布机-02', '辊压功率：', '辊压电压：','辊压频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_2涂布机glb_5_4"]);
     creatCanvas(['B-涂布机-03', '辊压功率：', '辊压电压：','辊压频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_2涂布机glb_5_5"]);
     creatCanvas(['B-终焊机-01', '焊接功率：', '焊接电压：','超声波频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_8终焊机glb_2"]);
     creatCanvas(['B-终焊机-02', '焊接功率：', '焊接电压：','超声波频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_8终焊机glb"]);
     creatCanvas(['B-终焊机-03', '焊接功率：', '焊接电压：','超声波频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_8终焊机glb_1"]);
     //锂电池C车
     creatCanvas(['C-辊压机-01', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_1_5"]);
     creatCanvas(['C-辊压机-02', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_1_6"]);
     creatCanvas(['C-辊压机-03', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_1_7"]);
     creatCanvas(['C-叠片机-01', '机械手速度：','运行速度：','设备效率：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + '%'],scope.spriteInfo["Box_6叠片机glb_3_0"]);
     creatCanvas(['C-叠片机-02', '机械手速度：','运行速度：','设备效率：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + '%'],scope.spriteInfo["Box_6叠片机glb"]);
     creatCanvas(['C-叠片机-03', '机械手速度：','运行速度：','设备效率：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + '%'],scope.spriteInfo["Box_6叠片机glb_2"]);
     creatCanvas(['C-涂布机-01', '辊压功率：', '辊压电压：','辊压频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_2涂布机glb_5_9_2"]);
     creatCanvas(['C-涂布机-02', '辊压功率：', '辊压电压：','辊压频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_2涂布机glb_5_10"]);
     creatCanvas(['C-涂布机-03', '辊压功率：', '辊压电压：','辊压频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_2涂布机glb_5_11"]);
     //锂电池D车间
     creatCanvas(['D-辊压机-01', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_1_2"]);
     creatCanvas(['D-辊压机-02', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_1_3"]);
     creatCanvas(['D-辊压机-03', '液压压力：', '运行速度：','左辊间隙：'],[random(9155,9855) + 'N',random(21000,35000) + 'm/min',random(90000,99000) + 'um'],scope.spriteInfo["Box_3辊压机glb_1_4"]);
     creatCanvas(['D-终焊机-01', '电压:', '终焊功率：','终焊时间：'],[random(9155,9855) + 'V',random(21000,35000) + 'W',random(90000,99000) + 'm/min'],scope.spriteInfo["Box_8终焊机glb_3_2"]);
     creatCanvas(['D-终焊机-02', '电压:', '终焊功率：','终焊时间：'],[random(9155,9855) + 'V',random(21000,35000) + 'W',random(90000,99000) + 'm/min'],scope.spriteInfo["Box_8终焊机glb_3_3"]);
     creatCanvas(['D-终焊机-03', '电压:', '终焊功率：','终焊时间：'],[random(9155,9855) + 'V',random(21000,35000) + 'W',random(90000,99000) + 'm/min'],scope.spriteInfo["Box_8终焊机glb_3_1"]);
     creatCanvas(['D-涂布机-01', '辊压功率：', '辊压电压：','辊压频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_2涂布机glb_5_9"]);
     creatCanvas(['D-涂布机-02', '辊压功率：', '辊压电压：','辊压频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_2涂布机glb_5_7"]);
     creatCanvas(['D-涂布机-03', '辊压功率：', '辊压电压：','辊压频率：'],[random(9155,9855) + 'w',random(21000,35000) + 'v',random(90000,99000) + 'hz'],scope.spriteInfo["Box_2涂布机glb_5_7_1"]);
     scope.isFirst = false;
  }
      function random(min, max) {
          return ((Math.floor(Math.random() * (max - min)) + min) / 100);
      }
    //关闭其它的房顶
    function clone(data, size, echartsUI,data1) {
      if (size == 0) {
        var flagData1 = []
        //500毫秒显示图表
        setTimeout(() => {
          for (let i = 0; i < scope.InfoUIArray.length; i++) {
            // 显示图表
            for (let j = i; j < scope.modelData.length; j++) {
              initTween(scope.modelData[j], false, 1);
              initgoup(scope.modelData[j], false, 205);
            }
          }
          //调用一次图表数据渲染上去
          for (let i = 0; i < scope.InfoUIdata.length; i++) {
            if (scope.InfoUIdata[i] != data1) {
              flagData1.push(scope.InfoUIdata[i]);
            }
          }
           //1秒显示图表数据
          setTimeout(() => {
            for (let i = 0; i < flagData1.length; i++) {
              scope.InfoUIArray[i].visible = true;
              flagData1[i].visible = true;
            }
          }, 600);
        }, 500);
      } else {
        var flagData = [];
        var echartsUIData = [];
        var flagData1 = []
        for (let i = 0; i < scope.modelData.length; i++) {
          if (scope.modelData[i] != data) {
            flagData.push(scope.modelData[i]);
          }
        }
        for (let i = 0; i < scope.echartsUI.length; i++) {
          if (scope.echartsUI[i] != echartsUI) {
            echartsUIData.push(scope.echartsUI[i]);
          }
        }
        for (let i = 0; i < scope.InfoUIdata.length; i++) {
          if (scope.InfoUIdata[i] != data1) {
            flagData1.push(scope.InfoUIdata[i]);
          }
        }
        //关闭其它的房顶
        setTimeout(() => {
          for (let i = 0; i < flagData.length; i++) {
            initTween(flagData[i], false, 1);
            initgoup(flagData[i], false, 205);
          }
        }, 500);
        //1秒显示图表
        setTimeout(() => {
          for (let i = 0; i < echartsUIData.length; i++) {
            echartsUIData[i].visible = true;
          }
        }, 1000);
        //1秒显示图表数据
        setTimeout(() => {
          for (let i = 0; i < flagData1.length; i++) {
            flagData1[i].visible = true;
          }
        }, 1000);
      }
    }

    //网页屏幕自适应
    function adaption() {
      window.addEventListener("resize", () => {
        scope.camera.aspect =
          scope.canvas.clientWidth / scope.canvas.clientHeight;
        scope.camera.updateProjectionMatrix();
        scope.renderer.setSize(
          scope.canvas.clientWidth,
          scope.canvas.clientHeight
        );
      });
    }

    //渲染场景
    function animate() {
      //获取当前系统时间
      scope.delta = scope.clock.getDelta ();
      //AGV动画
      if (scope.s_mixer){
        scope.s_mixer.update(scope.delta);
      }
      //流光
      if(scope.timeMap){
          scope.timeMap.offset.y += 0.006;
      }

      scope.controls.update();
      TWEEN.update();
      requestAnimationFrame(animate);


      scope.renderer.render(scope.scene, scope.camera);
    }

    function HasClickObj(name) {
      let thisName = null;
      if (scope.spriteInfo[name]) {
          thisName = name;
      }
      return thisName;
    }
  /**
       * 传入sprite名字，隐藏其他sprite
       * if name = null,全部隐藏
       * @param {String} name 
       */
     function SetSpriteVisible(name) {
      for (let i = 0; i < Object.keys(scope.spriteInfo).length; i++) {
          scope.spriteInfo[Object.keys(scope.spriteInfo)[i]].visible = false;
      }
      if (name != null) {
          scope.spriteInfo[name].visible = true;
      }
  }

  function creatCanvas(title, msg, sprite) {
    if (!sprite.visible && !scope.isFirst) {
        return;
    }
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    let w = scope.InfoImg.width;
    let h = scope.InfoImg.height;
    canvas.width = w * 4;
    canvas.height = h * 4;
    ctx.drawImage(scope.InfoImg, 0, 0, w * 4, h * 4);

    ctx.textBaseline = 'middle';
    ctx.scale(4, 4);
    ctx.fillStyle = '#FFF';
    ctx.font = '20px siYuan';
    ctx.textAlign = 'left';

    ctx.fillText(title[0], 20, h / ((title.length - 0.5) * 2));

    ctx.font = '18px siYuan';
    ctx.textAlign = 'center';
    // ctx.shadowOffsetX = 2;     //在X轴偏移值
    // ctx.shadowOffsetY = 3;    //在Y轴偏移值
    // ctx.shadowBlur = 10;       //阴影模糊程度
    // ctx.shadowColor = 'black';  //必填
    for (let i = 1; i < title.length; i++) {
        if (i == 1) {
            ctx.fillText(title[i], w / 3.5, 83);
        } else {
            ctx.fillText(title[i], w / 3.5, i * 40 + 40);
        }
    }
    ctx.font = '18px siYuan';
    ctx.textAlign = 'left';
    // ctx.shadowOffsetX = 2;     //在X轴偏移值
    // ctx.shadowOffsetY = 3;    //在Y轴偏移值
    // ctx.shadowBlur = 10;       //阴影模糊程度
    // ctx.shadowColor = 'black';  //必填
    ctx.fillStyle = '#ffffff';
    var gradient = ctx.createLinearGradient(0, 0, w / 4, 0);
    gradient.addColorStop('0', '#ffffff');
    gradient.addColorStop('1.0', '#00ffff');
    ctx.fillStyle = gradient;
    for (let i = 0; i < msg.length; i++) {
        if (i == 0) {
            ctx.fillText(msg[i], w / 1.8, 83);
        } else {
            ctx.fillText(msg[i], w / 1.8, (i + 1) * 40 + 40);
        }
    }
    var texture = new THREE.Texture(canvas);
    texture.needsUpdate = true;
    sprite.material.dispose(); 
    sprite.material = new THREE.SpriteMaterial({
        map: texture,
        //sizeAttenuation : false
    });

}
function LoadImg(src) {
  let img = new Image();
  img.src = src;
  img.onload = () => {
      scope.InfoImg = img;
  };
}

    // 解决echarts出现console未定义异常
    if (!window.console || !console.firebug){
      var names = ["log", "debug", "info", "warn", "error", "assert", "dir", "dirxml", "group", "groupEnd", "time", "timeEnd", "count", "trace", "profile", "profileEnd"];
   
      window.console = {};
      for (var i = 0; i < names.length; ++i)
          window.console[names[i]] = function() {
      }
  }
  }
}
export default ThreeDimensional;
